import React from "react"

export const VerticalDivider = ({ height }: any) => (
  <div
    style={{
      width: `1px`,
      height: `${height ? `${height}px` : `100%`}`,
      backgroundColor: `#ddd`,
      display: `block`,
    }}
  />
)
